module.exports = __webpack_public_path__ + "media/images/download_file-f78b2faa24c2a1962c475ecd48283177.svg";